import { useState } from "react";
import { faqs } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="你可能想知道的事"
          desc="关于题材定义、推荐机制、榜单更新与版权说明，这里集中解答同好最常见的问题。"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((f, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                  >
                    <i className="ri-add-line text-lg" aria-hidden="true"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="border-t border-background-200/80 pt-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}